/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuSubcategoryDto as DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuSubcategories/menu-subcategory-dto';

export interface GetMenuSubcategoryById$Params {
  menuCategoryId: string;
  menuSubcategoryId: string;
}

export function getMenuSubcategoryById(http: HttpClient, rootUrl: string, params: GetMenuSubcategoryById$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto>> {
  const rb = new RequestBuilder(rootUrl, getMenuSubcategoryById.PATH, 'get');
  if (params) {
    rb.path('menuCategoryId', params.menuCategoryId, {});
    rb.path('menuSubcategoryId', params.menuSubcategoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto>;
    })
  );
}

getMenuSubcategoryById.PATH = '/api/menu-categories/{menuCategoryId}/menu-subcategories/{menuSubcategoryId}';
